// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function exhaustiveMatchingGuard(_) {
    throw new Error("Should never get here");
}
